import { IDataTableColumn } from '../../dataTable/DataTable/model';
import { IconButton, Tooltip } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';

export interface IGTINPrefixRow extends Record<string, any> {
  onDelete?: (item: any) => void;
}

const gtinPrefixColumns: IDataTableColumn<IGTINPrefixRow>[] = [
  {
    name: 'GTIN Prefix Cloud ID',
    selector: (row) => row.autotreat_gtin_prefix_cloud_id,
    sortable: true,
  },
  {
    name: 'GTIN Prefix ID',
    selector: (row) => row.gtin_prefix_id,
    sortable: true,
  },
  {
    name: 'Prefix',
    selector: (row) => row.prefix,
    sortable: true,
  },
  {
    name: 'Company',
    selector: (row) => row.company,
    sortable: true,
  },
  {
    name: 'Description',
    selector: (row) => row.description,
    sortable: true,
  },
  {
    name: 'User Name',
    selector: (row) => row.user_name,
    sortable: true,
  },
  {
    name: 'Date and Time',
    selector: (row) => row.date_and_time,
    sortable: true,
  },
  {
    name: 'Active',
    selector: (row) => row.active,
    sortable: true,
    cell: (row) => (row.active ? 'True' : 'False'),
  },
  {
    name: 'Actions',
    selector: (row: IGTINPrefixRow) => '',
    cell: (row: IGTINPrefixRow) => {
      return (
        <Tooltip title="Delete GTIN Prefix">
          <IconButton 
            onClick={(e: React.MouseEvent) => {
              e.stopPropagation();
              if (row.onDelete) {
                row.onDelete(row);
              } else {
                console.error('onDelete handler not found on row');
              }
            }}
            size="small"
            color="error"
          >
            <DeleteIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      );
    },
    ignoreOnRowClick: true,
    allowOverflow: true,
    button: true,
  },
];

export default gtinPrefixColumns;
